import { Grid } from '@mui/material'
import { SectionHeader } from '@react/components/common/SectionHeader'
import PoolEditIcon from '@react/components/pools/PoolEditIcon'
import PoolLegalPage from '@react/components/pools/PoolLegalPage'
import React, { FC, useEffect, useState } from 'react'

interface Props {
  poolAddr: string
  onComplete: (addr: string) => void
}

export const VaultFilesStep: FC<Props> = ({ poolAddr, onComplete }) => {
  const [hasIcon, setHasIcon] = useState<boolean>(false)
  const [hasDocuments, setHasDocuments] = useState<boolean>(false)

  useEffect(() => {
    if (hasIcon && hasDocuments) onComplete(poolAddr)
  }, [hasIcon, hasDocuments])

  return (
    <>
      <SectionHeader>Vault Icon</SectionHeader>
      <Grid container sx={{ margin: 4 }}>
        <Grid item xs={12}>
          <PoolEditIcon poolAddr={poolAddr} setHasIcon={setHasIcon} />
        </Grid>
      </Grid>

      <SectionHeader>Vault Documentation and Files</SectionHeader>
      <Grid container>
        <Grid item xs={12}>
          <PoolLegalPage poolAddr={poolAddr} setHasRequiredDocs={setHasDocuments} />
        </Grid>
      </Grid>
    </>
  )
}
